var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{style:({
      width: '100%',
      height: `${_vm.height}px`,
      margin: '0 auto',
    }),attrs:{"id":_vm.id}})])
}
var staticRenderFns = []

export { render, staticRenderFns }